import { FAIcon } from "./faIcon.js";
import { Helper } from "../util/helper.js";
import { General, KeyboardShortcut } from "../../../siteManagement/general.js";
import { Config } from "../config/config.js";
import { Sheet } from "../../../siteManagement/sheet.js";
import { ObjectContextMenu, ObjectContextMenuEntry } from "./objectContextMenu.js";
import { LeftDrawerItem } from "./drawerItems.js";
import { EventType } from "../../../siteManagement/eventManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { MetadataNameViewer } from "../../core/components/formGenerator.js";
import { Saveable } from "./commonApp.js";
type StringOrBoolean = string | boolean;
import React from "react";
import ReactDOM from "react-dom";

export interface InternalEntry extends Required<MenuEntry> {
    _id: string;
    _hovered: boolean;
}

interface BMenuEntry {
    source: MenuEntry
    id: string;
}

interface BMenuState {
    entries: Array<BMenuEntry>;
    contextIsOpen: boolean;
    hoveredFloatingButtonId: string;
    isExtended: boolean;
}

export interface MenuEntryIcon {
    name: string;
    attributes?: Array<string>;
}

type clickHandlerType = (mouseButton: MouseButton) => void;
export interface MenuEntry {
    iskey?: string;
    text?: string;
    onClick?: string | clickHandlerType;
    icon?: string | MenuEntryIcon;
    icons?: Array<string | MenuEntryIcon>;
    show?: StringOrBoolean;
    inContext?: StringOrBoolean;
    floating?: StringOrBoolean;
    floatingColor?: string;
    floatingHoverAnimation?: string;
    floatingIconColor?: string;
    type?: EntryType;
    data?: EntryData;
    reevaluate?: Array<keyof MenuEntry>;
    shortCut?: string;
    extendedView?: string | boolean;
}

export interface EntryData {
    params?: Array<any>;
}

export interface BMenuProps {
    entries: Array<MenuEntry>
    enableMenuItem(action: string | boolean, prepare?: any);
    onSelect(action: string, mouseButton: MouseButton);
    handleEval(action: string, prepare?: any);
    sheet?: Sheet;
    loadedModules?: Saveable[];
    debug?: boolean;
}

export enum EntryType {
    Save = "save",
    Delete = "delete",
    New = "new",
    //Separator = "separator",
    Email = "email",
    EmailHistory = "emailhistory",
    Follow = "follow",
    Geomap = "geomap",
    //...
    QRReport = "qrreport",
    Other = "other",
    LikeSave = "likesave",
    PrintDialog = "printdialog"
}

export enum MouseButton {
    Unknown = -1, Left = 0, Middle = 1, Right = 2
}

export class Menu extends React.Component<BMenuProps, BMenuState> {
    private _sheet: Sheet = null;
    //heuristisch -> bei Bedarf bitte aktualisieren...
    private _hash: string = null;
    private _shortCuts: {
        shortCut: KeyboardShortcut,
        id: string
    }[] = [];


    constructor(props: BMenuProps) {
        super(props);

        const entries = this._createStateEntry(props.entries);
        this._shortCuts = this._shortCuts.filter(f => Helper.hasValue(f.shortCut));

        this.state = {
            entries,
            contextIsOpen: false,
            hoveredFloatingButtonId: null,
            isExtended: false
        };

        this._hash = this._hashButtons(props.entries);
        this._sheet = this.props.sheet || General.Sheet.Manager.getTopMostSheet();
        this._onEntryClick = Helper.throttle(this._onEntryClick);
    }


    private _hashButtons = (buttons: Array<MenuEntry>) => {
        if (Array.isArray(buttons)) {
            return buttons.map(b => b.text).join("*");
        } else {
            return "";
        }
    }

    private _createStateEntry = (entries: Array<MenuEntry>) => {
        const result: Array<BMenuEntry> = [];
        let id = "";
        if (Array.isArray(entries)) {
            entries.forEach(e => {
                id = kendo.guid();
                const entry: BMenuEntry = {
                    source: getMenuEntryData(e),
                    id: id
                };
                this._shortCuts.push({
                    shortCut: this._createShortCut(entry),
                    id: id
                });
                result.push(entry);
            });
        }
        return result;
    }

    private _initShortCuts = () => {
        const getId = (shortCut: KeyboardShortcut) => {
            const possibleIds = this._shortCuts.filter(f => f.shortCut.key === shortCut.key).map((sc) => {
                return sc.id;
            })
            const visibleIds = this.state.entries.filter(f => this._isEntryVisible(f.source)).map((e) => {
                return e.id;
            });
            let ids = possibleIds.filter(f => visibleIds.indexOf(f) !== -1);

            if (ids.length === 1) {
                return ids[0];
            } else if (ids.length > 1) {
                NotificationHelper.showWarningMessage("Your shortcuts have not been configured correctly");
                const systemIds = this.state.entries.filter(f => f.source.type !== EntryType.Other).map((e) => {
                    return e.id;
                });
                ids = ids.filter(f => systemIds.indexOf(f) !== -1);
                if (ids.length === 1) {
                    return ids[0];
                }
            }
            return null;
        }

        const isUsable = (shortCut: KeyboardShortcut) => {
            const reservedShortCuts: KeyboardShortcut[] = [
                {
                    alt: false,
                    ctrl: false,
                    key: "escape",
                    shift: false

                }, {
                    alt: false,
                    ctrl: true,
                    key: "i",
                    shift: false
                }, {
                    alt: false,
                    ctrl: true,
                    key: "m",
                    shift: false
                }
            ];

            let lst = reservedShortCuts
                .filter(f => f.alt == shortCut.alt
                    && f.ctrl == shortCut.ctrl
                    && f.shift == shortCut.shift
                    && f.key.toLowerCase() === shortCut.key.toLowerCase());
            return (lst.length === 0 && (shortCut.alt || shortCut.ctrl));
        }

        General.Events.bind(EventType.ShortCut, (shortcut: KeyboardShortcut) => {
            let id = "";
            if (isUsable(shortcut)) {
                id = getId(shortcut);
            }
            if (!Helper.isNullOrEmpty(id) && this._sheet === General.Sheet.Manager.getTopMostSheet()) {
                let $focused = $(':focus')[0];
                if (Helper.hasValue($focused)) {
                    $focused.blur();
                }
                this._onEntryClick(id)
                if (Helper.hasValue($focused)) {
                    $focused.focus();
                }
            }
        });
    }

    private _createShortCut = (entry: BMenuEntry) => {
        let shortCut = entry.source.shortCut;
        if (!Helper.isNullOrEmpty(shortCut)) {
            let keys = shortCut.split(" + ");
            const selectedKeys = keys.filter(f => (f.trim() != "ctrl") && (f.trim() != "alt") && (f.trim() != "shift"));
            if (selectedKeys.length === 1) {
                let shortCut: KeyboardShortcut = {
                    key: selectedKeys[0].trim(),
                    shift: keys.filter(f => f.trim() === "shift").length === 1,
                    alt: keys.filter(f => f.trim() === "alt").length === 1,
                    ctrl: keys.filter(f => f.trim() === "ctrl").length === 1
                }
                return shortCut;
            } else {
                return null;
            }
        }
    }

    private _onContextMenuSelected = (contextEntry: ObjectContextMenuEntry) => {
        const target = this.state.entries.filter(x => x.id === contextEntry.id)[0];
        if (target && typeof target.source.onClick === "string") {
            this.props.onSelect(target.source.onClick, MouseButton.Left);
        }
        else if (target && typeof target.source.onClick == "function") {
            target.source.onClick(MouseButton.Left)
        }
    }

    private _onEntrySelected = (entry: BMenuEntry) => {

        if (typeof entry.source.onClick === "string") {
            this.props.onSelect(entry.source.onClick, MouseButton.Left);
        }
        else if (typeof entry.source.onClick === "function") {
            entry.source.onClick(MouseButton.Left);
        }
    }

    private _isEntryVisible = (entry: MenuEntry): boolean => {
        if (typeof entry.show === "boolean") {
            return entry.show;
        }

        //AG - wenn is inContext, dann show beim verwenden prüfen, hier immer show = true
        if (entry.inContext === true)
            return true;

        return this.props.enableMenuItem(entry.show);
    }

    private _isExtendedView = (entry: MenuEntry): boolean => {
        return (entry.extendedView !== undefined && entry.extendedView === true) || (typeof (entry.extendedView) === "string" && this.props.handleEval(entry.extendedView as string));
    }

    private _hasExtendedViews = () => {
        return this.state.entries.filter(e => this._isExtendedView(e.source)).length > 0;
    }

    private _onEntryClick = (id: string) => {
        if (Helper.useMobileGui()) {
            General.Drawer.Left.close();
        };
        const target = this.state.entries.filter(x => x.id === id)[0];
        this._onEntrySelected(target);
    }

    private _getEntriesToRender = () => {
        const entries: Array<InternalEntry> = [];
        this.state.entries.forEach(e => {
            let isExtenedView = this._isExtendedView(e.source);
            if (this._isEntryVisible(e.source) && (!isExtenedView || (isExtenedView && this.state.isExtended))) {
                const ie: InternalEntry = {
                    iskey: e.source.iskey,
                    data: e.source.data,
                    floating: typeof e.source.floating === "string" ? this.props.handleEval(e.source.floating) : e.source.floating,
                    floatingColor: e.source.floatingColor,
                    floatingHoverAnimation: e.source.floatingHoverAnimation,
                    floatingIconColor: e.source.floatingIconColor,
                    icon: e.source.icon,
                    icons: e.source.icons,
                    inContext: typeof e.source.inContext === "string" ? this.props.handleEval(e.source.inContext) : e.source.inContext,
                    onClick: e.source.onClick,
                    reevaluate: e.source.reevaluate,
                    show: e.source.show,
                    text: e.source.text,
                    type: e.source.type,
                    _id: e.id,
                    _hovered: e.id === this.state.hoveredFloatingButtonId,
                    shortCut: e.source.shortCut,
                    extendedView: e.source.extendedView
                };

                if (Array.isArray(ie.reevaluate)) {
                    ie.reevaluate.forEach(p => {
                        const original = ie[p];
                        if (typeof original === "string") {
                            ie[p] = this.props.handleEval(original);
                        }
                    });
                }

                entries.push(ie);
            }
        });

        return entries;
    }

    private _getIconName = (icon: string | MenuEntryIcon): string => {
        return typeof icon === "string" ? icon : icon.name;
    }

    private _getIconAttributes = (icon: string | MenuEntryIcon, existing?: Array<string>): Array<string> => {
        const attributes = Array.isArray(existing) ? existing.slice(0) : [];
        if (typeof icon !== "string" && Array.isArray(icon.attributes)) {
            icon.attributes.forEach(a => attributes.push(a));
        }

        return attributes;
    }

    private _toggleHoverState = (on: boolean, button: InternalEntry) => {
        this.setState({ hoveredFloatingButtonId: on ? button._id : null });
    }

    componentDidMount() {
        this._initShortCuts();
        this.setState({});
    }

    componentDidUpdate(prevProps: BMenuProps, prevState: BMenuState, snapshot) {
        const hash = this._hashButtons(this.props.entries);
        if (this.props.entries !== prevProps.entries || hash !== this._hash) {
            this._hash = hash;
            this.setState({ entries: this._createStateEntry(this.props.entries) });
        }
    }

    hasUnsavedModules = (): boolean => {
        if (!this.props.loadedModules) {
            return false;
        }

        for (const m of this.props.loadedModules) {
            if (m.HasChanges()) {
                return true;
            }
        }
    }

    render() {
        const visibleEntries = this._getEntriesToRender();
        const contextActions = visibleEntries.filter(x => x.inContext);
        const actions = visibleEntries.filter(x => !x.inContext && x.type !== EntryType.Save);
        const saveEntry: InternalEntry = visibleEntries.filter(x => x.type === EntryType.Save)[0] || null;
        const contextMenuEntries: Array<ObjectContextMenuEntry> = contextActions.map((ca): ObjectContextMenuEntry => {
            if (typeof ca.icon === "string") {
                return {
                    text: ca.text,
                    id: ca._id,
                    icon: ca.icon,
                    show: ca.show
                };
            } else {
                return {
                    text: ca.text,
                    id: ca._id,
                    icon: ca.icon.name,
                    show: ca.show
                };
            }
        });
        const floatingEntries = visibleEntries.filter(x => x.floating);
        //if (saveEntry && saveEntry.floating === true) {
        //    floatingEntries.unshift(saveEntry);
        //}
        const hasChanges = this._sheet.hasUnsavedChanges() || this.hasUnsavedModules();

        return (
            <>
                {
                    //save button
                    ReactDOM.createPortal(
                        <>
                            {
                                saveEntry ?
                                    <div className="sheet__main-action--save" title={saveEntry.text} onClick={_ => this._onEntryClick(saveEntry._id)} style={{ cursor: "pointer", color: hasChanges ? "#4CAF50" : null }} id={saveEntry._id}>
                                        <FAIcon name={this._getIconName(saveEntry.icon)} sameWidth={true} attributes={["2x"]} />
                                    </div>
                                    : null
                            }
                        </>,
                        this._sheet.elements.getMainActionsRef()[0]
                    )
                }
                {
                    //left drawer actions
                    ReactDOM.createPortal(
                        <>
                            {
                                actions.length > 0 ?
                                    <>
                                        < label className="section-label">{Config.translations.actions}</label>
                                        {
                                            actions.map(x => {
                                                return (<React.Fragment key={x._id}>
                                                    {this.props.debug ? <MetadataNameViewer metadataName={x["iskey"]} backgroundColor="lightgreen" /> : null}
                                                    <LeftDrawerItem label={x.text} icon={this._getIconName(x.icon)} icons={x.icons.map(this._getIconName)} id={x._id} onClick={this._onEntryClick} />
                                                </React.Fragment>
                                                );
                                            })
                                        }
                                        {
                                            this._hasExtendedViews() ?
                                                <div style={{ color: "#069" }}>
                                                    <LeftDrawerItem label={this.state.isExtended ? Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowLess") : Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowMore")}
                                                        icon={this.state.isExtended ? "caret-up" : "caret-down"}
                                                        onClick={() => { this.setState({ isExtended: !this.state.isExtended }) }}
                                                        id="extendedViewMenu" />
                                                </div> : null
                                        }
                                    </>
                                    : null
                            }
                        </>,
                        this._sheet.elements.getLeftDrawerElementRef()[0]
                    )
                }
                {
                    //context actions
                    ReactDOM.createPortal(
                        contextActions.length > 0 ?
                            <ObjectContextMenu entries={contextMenuEntries} onSelect={this._onContextMenuSelected} enableMenuItem={this.props.enableMenuItem} />
                            : null,
                        this._sheet.elements.getContextActionsRef()[0]
                    )
                }
                {
                    //floating buttons
                    ReactDOM.createPortal(
                        <>
                            {
                                floatingEntries.map(fe => {
                                    return (
                                        <div
                                            id={fe._id}
                                            key={fe._id}
                                            className={`sheet__action ${fe.type === EntryType.Other ? "" : (fe.type === EntryType.LikeSave ? EntryType.Save : fe.type)}`}
                                            title={fe.text}
                                            style={{ backgroundColor: Helper.hasValue(fe.floatingColor) ? fe.floatingColor : "var(--default-corporate-backGroundColor)", color: fe.floatingIconColor }}
                                            onClick={_ => this._onEntryClick(fe._id)}
                                            onMouseEnter={_ => this._toggleHoverState(true, fe)}
                                            onMouseLeave={_ => this._toggleHoverState(false, fe)}
                                        >
                                            <FAIcon name={this._getIconName(fe.icon)} attributes={this._getIconAttributes(fe.icon, ["2x"])} wrapperClass={fe._id === this.state.hoveredFloatingButtonId ? fe.floatingHoverAnimation : null} />
                                        </div>
                                    );
                                })
                            }
                        </>,
                        this._sheet.elements.getMenuRef()[0]
                    )
                }
            </>
        );
    }
}

export const getMenuEntryData = (source: MenuEntry) => {
    const defaults = menuEntryDefaults(source.type, source.data);
    const merged: Required<MenuEntry> = {
        iskey: source.iskey,
        data: defaults.data,
        floating: Helper.hasValue(source.floating) ? source.floating : defaults.floating,
        floatingColor: Helper.hasValue(source.floatingColor) ? source.floatingColor : defaults.floatingColor,
        floatingHoverAnimation: Helper.hasValue(source.floatingHoverAnimation) ? source.floatingHoverAnimation : defaults.floatingHoverAnimation,
        floatingIconColor: Helper.hasValue(source.floatingIconColor) ? source.floatingIconColor : defaults.floatingIconColor,
        icon: Helper.hasValue(source.icon) ? source.icon : defaults.icon,
        icons: Array.isArray(source.icons) ? source.icons.slice(0) : defaults.icons.slice(0),
        inContext: Helper.hasValue(source.inContext) ? source.inContext : defaults.inContext,
        onClick: Helper.hasValue(source.onClick) ? source.onClick : defaults.onClick,
        reevaluate: Array.isArray(source.reevaluate) ? source.reevaluate.slice(0) : defaults.reevaluate.slice(0),
        show: Helper.hasValue(source.show) ? source.show : defaults.show,
        text: Helper.hasValue(source.text) ? source.text : defaults.text,
        type: Helper.hasValue(source.type) ? source.type : defaults.type,
        shortCut: Helper.hasValue(source.shortCut) ? source.shortCut : defaults.shortCut,
        extendedView: Helper.hasValue(source.extendedView) ? source.extendedView : defaults.extendedView
    };

    return merged;
}

export const menuEntryDefaults = (type: EntryType, data?: EntryData) => {
    const btn: Required<MenuEntry> = {
        iskey: null,
        data: Helper.hasValue(data) ? data : null,
        floating: false,
        floatingColor: null,//"#767676",
        floatingIconColor: null,//"white",
        floatingHoverAnimation: null,
        icon: "arrow-circle-right ",
        icons: [],
        onClick: null,
        inContext: false,
        show: true,
        text: null,
        type: type || EntryType.Other,
        reevaluate: [],
        shortCut: null,
        extendedView: false
    };
    switch (type) {
        case EntryType.Save:
            btn.icon = "check";
            btn.onClick = "save()";
            btn.text = Config.translations.saveLabel;
            btn.floatingColor = "#4CAF50";
            btn.show = "entity.RecordRight.CanWrite";
            btn.shortCut = "ctrl + s";
            break;
        case EntryType.Email:
            btn.icon = "envelope";
            btn.inContext = true;
            btn.onClick = "openEmail()";
            btn.show = "entity.IsNew !== true";
            btn.text = Config.translations.email;
            break;
        case EntryType.EmailHistory:
            btn.icon = "inbox-out";
            btn.inContext = true;
            btn.onClick = "openEmail(true)";
            btn.show = "entity.IsNew !== true";
            btn.text = Config.translations.emailHistory;
            break;
        case EntryType.Follow:
            btn.icon = "eye";
            btn.onClick = btn.data ? `toggleFollow('${btn.data.params[0]}')` : null;
            btn.show = "!entity.IsNew && entity.IsWatchable";
            btn.text = `entity.IsWatched ? '${Config.translations.unfollow}': '${Config.translations.follow}'`;
            btn.reevaluate = ["text"];
            btn.shortCut = "ctrl + alt + f";
            break;
        case EntryType.Geomap:
            btn.icon = "map-pin";
            btn.onClick = btn.data ? `addToGeomapRoute('${btn.data.params[0]}')` : null;
            btn.show = "!entity.IsNew && !saveEnabled && entity.GeocodeEnabled";
            btn.text = Config.translations.addPointToRoute
            btn.shortCut = "ctrl + alt + g";
            break;
        case EntryType.QRReport:
            btn.icon = "print";
            btn.onClick = btn.data ? `createReport(${JSON.stringify(btn.data.params[0])})` : null;
            btn.text = "Generate report";
            btn.show = "!entity.IsNew && Innosoft.Config.user.qrEnabled"
            break;
        case EntryType.New:
            btn.icon = "plus";
            btn.text = Config.translations.newLabel;
            btn.shortCut = "ctrl + alt + n";
            break;
        case EntryType.Delete:
            btn.icon = "trash-alt";
            btn.inContext = true;
            btn.text = Config.translations.deleteLabel;
            btn.shortCut = "ctrl + alt + d";
            break;
        case EntryType.PrintDialog:
            btn.icon = "print";
            btn.text = Config.translations.openPrintDialog;
            btn.onClick = btn.data ? `openPrintDialog(${JSON.stringify(btn.data)})` : "openPrintDialog()";
            btn.show = "!entity.IsNew && Innosoft.Config.user.qrEnabled";
            btn.shortCut = "ctrl + p";
            break;
        default:
            break;
    }
    return btn;
}